import React from 'react';
export const SmlsHeaderPlaceholder = ({ redirectUrl, }) => {
    return (React.createElement("div", { className: "smls-header-placeholder" },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            } },
            React.createElement("a", { href: redirectUrl || '/home' },
                React.createElement("span", { className: "smls-logos smiles" },
                    React.createElement("b", null, "Smiles"))))));
};
//# sourceMappingURL=index.js.map